/*
 * Haye Nii: floating "Add to cart" card at the bottom of the phone screen (snippets/sticky-add-to-cart.liquid).
 * Tapping it presses the real button, so the name/option checks and the cart work exactly as usual.
 *
 * Task 38 (owner: "never covering what the shopper needs"). The card shows only when it helps:
 *  - hidden while the real Add to cart button is on screen,
 *  - hidden while the name box, language, fonts or options are where the card would sit (bottom of the screen),
 *  - hidden while a dropdown list or a picture guide is open (html.hn-dd-open / html.po-guide-open,
 *    assets/product-options.js), and while the shopper types (keyboard up).
 * So it floats over the photos and title, and again below the button (details, reviews), never over a field.
 */
(function () {
  var bar = document.querySelector('[data-hn-sticky-atc]');
  if (!bar) return;
  var form = document.getElementById(bar.dataset.form);
  var realButton = form && form.querySelector('[name="add"]');
  if (!realButton) return;
  var area = form.closest('product-info') || document;
  var barButton = bar.querySelector('[data-hn-sticky-button]');
  var priceOut = bar.querySelector('[data-hn-sticky-price]');
  var phone = window.matchMedia('(max-width: 749px)'); // the card is for phones only (see sticky-add-to-cart.css)
  var shown = false;
  var lifted = false;
  var ready = false; // wait for the first layout, so the card never flashes on load
  var queued = false;

  // The parts the shopper fills in: the card must never sit on top of them
  var ZONE = 'variant-selects, .product-options-block, .product-form__input, .product-form__quantity';
  var TYPING = 'input:not([type="button"]):not([type="submit"]):not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea, select';

  // Same price and sold-out state as the real price/button
  function sync() {
    // The theme may redraw the real button when a variant changes: follow the new one
    var current = form.querySelector('[name="add"]');
    if (current && current !== realButton) realButton = current;
    var priceBox = document.getElementById(bar.dataset.price);
    if (priceBox) {
      var onSale = priceBox.querySelector('.price--on-sale');
      var price = onSale
        ? priceBox.querySelector('.price__sale .price-item--sale')
        : priceBox.querySelector('.price__regular .price-item--regular');
      if (price) priceOut.textContent = price.textContent.trim();
    }
    barButton.disabled = realButton.disabled;
    var label = realButton.querySelector('span');
    var text = (label || realButton).textContent.trim();
    if (text && barButton.textContent !== text) barButton.textContent = text;
  }

  function onScreen(el, top, bottom) {
    if (!el || !el.offsetParent) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.top < bottom && r.bottom > top;
  }

  // Height of the strip at the bottom of the screen that the card covers (card + space under it)
  function band() {
    var gap = parseFloat(getComputedStyle(bar).bottom) || 0;
    return (bar.offsetHeight || 64) + gap + 12;
  }

  function wanted() {
    if (!phone.matches || !ready) return false;
    var h = window.innerHeight;
    if (onScreen(realButton, 0, h)) return false;
    var root = document.documentElement;
    if (root.classList.contains('hn-dd-open') || root.classList.contains('po-guide-open')) return false;
    var active = document.activeElement;
    if (active && active !== document.body && active.matches && active.matches(TYPING)) return false;
    var strip = h - band();
    var parts = area.querySelectorAll(ZONE);
    for (var i = 0; i < parts.length; i++) {
      if (onScreen(parts[i], strip, h)) return false;
    }
    return true;
  }

  // The SmartBot chat bubble sits bottom-right inside the app's own (shadow) box: lift it above the card
  function liftChat(on) {
    var host = document.getElementById('smart-bot-container');
    var root = host && host.shadowRoot;
    if (!root) return;
    var style = root.getElementById('hn-lift-chat');
    if (!style) {
      style = document.createElement('style');
      style.id = 'hn-lift-chat';
      root.appendChild(style);
    }
    style.textContent =
      '[class*="chat-icon-container"]{transition:bottom .45s cubic-bezier(.32,.72,0,1);' +
      (on ? 'bottom:' + Math.round(band()) + 'px !important;' : '') +
      '}';
  }

  function update() {
    queued = false;
    var show = wanted();
    if (show === shown) return;
    shown = show;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    barButton.tabIndex = show ? 0 : -1;
    document.documentElement.classList.toggle('hn-sticky-atc-on', show);
    if (show !== lifted) {
      lifted = show;
      liftChat(show);
    }
  }

  function later() {
    if (queued) return;
    queued = true;
    setTimeout(update, 16);
  }

  window.addEventListener('scroll', later, { passive: true });
  window.addEventListener('resize', later);
  document.addEventListener('focusin', later);
  document.addEventListener('focusout', function () { setTimeout(later, 50); });
  if (phone.addEventListener) phone.addEventListener('change', later);

  // A list or picture guide opens/closes (class on <html>)
  new MutationObserver(later).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // Keep price/sold-out in step when the shopper changes Plating, Length, ...; the area also grows (fonts appear)
  new MutationObserver(function () {
    sync();
    later();
  }).observe(area === document ? form : area, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });

  barButton.addEventListener('click', function () {
    if (realButton.disabled) return;
    realButton.click(); // runs every check; a missing name scrolls up to the name box
  });

  // The chat app loads after the page: apply the lift once it is there
  var tries = 0;
  var waitForChat = setInterval(function () {
    tries++;
    if (document.getElementById('smart-bot-container') || tries > 20) {
      clearInterval(waitForChat);
      liftChat(lifted);
    }
  }, 1000);

  sync();
  setTimeout(function () {
    ready = true;
    update();
  }, 50);
})();
